import { useState, useEffect } from 'react';
import { get } from '../utils/fetch';
import camelCaseKeys from 'camelcase-keys';
import { Log } from '../../../clients/sidebar/models/Task';

type Props = {
  taskId: number | null;
  projectId: number;
  bugherdUrl: string;
};

export const useLogs = ({
  taskId,
  projectId,
  bugherdUrl
}: Props): {
  logs: Log[];
  addLog: (taskLog: Log) => void;
  loading: boolean;
} => {
  const [logs, setLogs] = useState<Log[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const endpoint = `${bugherdUrl}/projects/${projectId}/tasks/${taskId}/comments/logs`;

  const getLogs = async () => {
    setLoading(true);
    try {
      const response = await get(endpoint);
      setLogs(camelCaseKeys(response, { deep: true }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (taskId && projectId && bugherdUrl) getLogs();
  }, [taskId, projectId, bugherdUrl]);

  const addLog = (log: Log) => {
    setLogs(prevLogs => [log, ...prevLogs]);
  };

  return { logs, addLog, loading };
};
